module.exports = __webpack_public_path__ + "img/ys.f9f9b445.png";